var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmRhistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3189 4.81115C18.479 2.97121 15.9372 1.83313 13.1296 1.83313C7.51462 1.83313 2.9625 6.38521 2.9625 12.0003H0.703125L4.46873 15.766L8.23439 12.0003H5.97502C5.97502 8.04889 9.17831 4.84565 13.1297 4.84565C15.1054 4.84565 16.8941 5.64646 18.1888 6.94119C19.4836 8.23593 20.2844 10.0247 20.2844 12.0003C20.2844 15.9517 17.0811 19.155 13.1297 19.155C11.8315 19.155 10.6142 18.8089 9.56461 18.2045C9.56034 18.202 9.55659 18.199 9.55233 18.1965C8.832 17.7806 7.91081 18.0274 7.49484 18.7477C7.07883 19.4682 7.32567 20.3894 8.04609 20.8053L8.04539 20.8065C9.54103 21.672 11.2774 22.1676 13.1296 22.1676C18.7448 22.1676 23.2968 17.6156 23.2968 12.0004C23.2969 9.19274 22.1588 6.65099 20.3189 4.81115Z",
    fill: "#F85647",
    stroke: "#242222",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 9C12.3148 9 12 9.31486 12 9.70312V13.8453C12 14.2336 12.3148 14.5485 12.7031 14.5485H16.0922C16.4805 14.5485 16.7953 14.2336 16.7953 13.8453C16.7953 13.457 16.4805 13.1422 16.0922 13.1422H13.4062V9.70312C13.4062 9.31486 13.0914 9 12.7031 9Z",
    fill: "#242222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmRhistory);
export default __webpack_public_path__ + "static/media/EMR history.14c507cd0743a9a89a25456c7ef249eb.svg";
export { ForwardRef as ReactComponent };